var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.pageList.length)?_c('TemplateView',[_c('v-container',[(_vm.childPage)?_c('router-view'):[_c('div',{staticClass:"d-flex flex-wrap gap-3 gap-md-5 mb-8"},_vm._l((_vm.pageList),function(page,p){return _c('BaseButton',{key:'page_' + p,attrs:{"text":page.text,"style-type":"chip","disabled":_vm.$route.name === page.toName},on:{"click":function($event){return _vm.$router.push({ name: page.toName })}}})}),1),_c('router-view')]],2)],1):_c('div',[_c('div',{staticClass:"d-flex flex-wrap gap-3 gap-md-5 mb-8"},[_vm._l((_vm.tabList),function(tab,t){return [(_vm.$userCheckAccess({abilities: tab.abilities}))?_c('BaseButton',{key:'tab_' + t,attrs:{"text":tab.text,"style-type":"chip","disabled":_vm.$route.query.tab === tab.tab},on:{"click":function($event){return _vm.goToTab({
        name: tab.toName,
        params: { id: _vm.$route.params.id },
        query: {
          tab: tab.tab,
          subTab: _vm.$route.query.subTab,
          office_page: _vm.$route.query.office_page,
          office_limit: _vm.$route.query.office_limit,
          address_page: _vm.$route.query.address_page,
          address_limit: _vm.$route.query.address_limit,
          email_page: _vm.$route.query.email_page,
          email_limit: _vm.$route.query.email_limit,
          phone_page: _vm.$route.query.phone_page,
          phone_limit: _vm.$route.query.phone_limit,
          person_page: _vm.$route.query.person_page,
          person_limit: _vm.$route.query.person_limit,
          grid: _vm.$route.query.grid,
          project_page: _vm.$route.query.project_page,
          project_limit: _vm.$route.query.project_limit,
        },
      })}}}):_vm._e()]})],2),_vm._l((_vm.tabList),function(tab,t){return [(_vm.$route.query.tab === 'projects' && tab.subTab.length > 0)?_c('div',{key:'subTabWrapper_' + t,staticClass:"d-flex flex-wrap gap-3 gap-md-5 mb-8 mt-4"},[_vm._l((tab.subTab),function(sub,s){return [(_vm.$userCheckAccess({abilities: sub.abilities}))?_c('BaseButton',{key:'subTab_' + s,attrs:{"text":sub.text,"style-type":"chip","disabled":_vm.$route.query.subTab === sub.tab},on:{"click":function($event){return _vm.goToTab({
        name: sub.toName,
        params: { id: _vm.$route.params.id },
        query: {
          tab: tab.tab,
          subTab: sub.tab,
          office_page: _vm.$route.query.office_page,
          office_limit: _vm.$route.query.office_limit,
          address_page: _vm.$route.query.address_page,
          address_limit: _vm.$route.query.address_limit,
          email_page: _vm.$route.query.email_page,
          email_limit: _vm.$route.query.email_limit,
          phone_page: _vm.$route.query.phone_page,
          phone_limit: _vm.$route.query.phone_limit,
          person_page: _vm.$route.query.person_page,
          person_limit: _vm.$route.query.person_limit,
          grid: _vm.$route.query.grid,
          project_page: _vm.$route.query.project_page,
          project_limit: _vm.$route.query.project_limit,
        },
      })}}}):_vm._e()]})],2):_vm._e()]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }